import { useAppSelector } from '../../hooks';

export const useLocationsSelector = (): string[] =>
  useAppSelector(({ locations }) => locations.previousLocations);
